import TourDataMapViewController from "./tour_data_map_view_controller"

const SCENIC_SPOT_LEVELS = {
    0: { desc: "无级别", color: "#0cc2f2" },
    1: { desc: "1A级", color: "#4fd2b1" },
    2: { desc: "2A级", color: "#90e36f" },
    3: { desc: "3A级", color: "#ffe700" },
    4: { desc: "4A级", color: "#ff1800" },
    5: { desc: "5A级", color: "#ff6700" },
}

export default class extends TourDataMapViewController {

    connect() {
        super.connect()
        this.initFilterButtons()
    }

    getHoverTitle(dataItem) {
        const levelDesc = SCENIC_SPOT_LEVELS[dataItem.level].desc
        return `${levelDesc}: ${dataItem.title}`
    }

    getRenderOptions(PointsSimplifier) {
        const renderConstructor = PointsSimplifier.Render.Canvas.GroupStyleRender

        const groupStyleOptions = {}

        for (const level in SCENIC_SPOT_LEVELS) {
            groupStyleOptions[level] = {
                pointStyle: { fillStyle: SCENIC_SPOT_LEVELS[level].color }
            }
        }

        const renderOptions = {
            getGroupId: function(dataItem, index) {
                return dataItem.level
            },
            groupStyleOptions: groupStyleOptions,
        }

        return [renderConstructor, renderOptions]
    }

    setTitleWithData(dataSource) {
        const levelCounters = {}

        dataSource.forEach((object) => {
            const level = object.level
            let count = levelCounters[level]

            if (count) {
                levelCounters[level] = count + 1
            } else {
                levelCounters[level] = 1
            }
        })

        let title = `共${dataSource.length}个景点`
        let subtitle = ""

        for (let key in levelCounters) {
            const desc = SCENIC_SPOT_LEVELS[key].desc

            if (desc) {
                subtitle += `${desc}:${levelCounters[key]} `
            }
        }

        if (subtitle) {
            title += ` - ${subtitle}`
        }

        this.titleElement.innerText = title
    }

    initFilterButtons() {
        const panel = document.createElement("div")
        let filterButtonsHTML = ""

        for (let level in SCENIC_SPOT_LEVELS) {
            const object = SCENIC_SPOT_LEVELS[level]
            filterButtonsHTML += `<button class="button is-small" data-level="${level}" style="background-color:${object.color}">${object.desc}</button>`
        }

        panel.innerHTML = `<div class='box p-3' style='position:absolute;right:20px;top:calc(3.25rem + 20px)'>
                          <div class="is-flex is-flex-direction-column">${filterButtonsHTML}</div></div>`

        this.element.appendChild(panel)

        panel.querySelectorAll("button").forEach((button) => {
            button.addEventListener("click", (event) => {
                event.target.classList.toggle("is-selected")

                let filteredLevels = []

                panel.querySelectorAll("button.is-selected").forEach((button) => {
                    filteredLevels.push(parseInt(button.dataset.level))
                })

                let filteredData = null

                if (filteredLevels.length > 0) {
                    filteredData = this.dataSource.filter((object) => filteredLevels.indexOf(object.level) !== -1)
                } else {
                    filteredData = this.dataSource
                }

                this.pointsSimplifier.setData(filteredData)
                this.setTitleWithData(filteredData)
            })
        })
    }
}